// extracted by mini-css-extract-plugin
export default {"defaultSwiper":"CustomSwiper_defaultSwiper__KG-7E"};